import { Modal, Select, Button } from 'antd';
import React, { useState, useEffect } from 'react';
import useCountryStore from '../../Store/countryStore';

// List of countries (ISO 3166-1 alpha-2 codes) - sorted alphabetically
const COUNTRIES_RAW = [
    { code: 'US', name: 'United States' },
    { code: 'GB', name: 'United Kingdom' },
    { code: 'CA', name: 'Canada' },
    { code: 'AU', name: 'Australia' },
    { code: 'DE', name: 'Germany' },
    { code: 'FR', name: 'France' },
    { code: 'IT', name: 'Italy' },
    { code: 'ES', name: 'Spain' },
    { code: 'NL', name: 'Netherlands' },
    { code: 'BE', name: 'Belgium' },
    { code: 'CH', name: 'Switzerland' },
    { code: 'AT', name: 'Austria' },
    { code: 'SE', name: 'Sweden' },
    { code: 'NO', name: 'Norway' },
    { code: 'DK', name: 'Denmark' },
    { code: 'FI', name: 'Finland' },
    { code: 'IE', name: 'Ireland' },
    { code: 'PT', name: 'Portugal' },
    { code: 'GR', name: 'Greece' },
    { code: 'PL', name: 'Poland' },
    { code: 'CZ', name: 'Czech Republic' },
    { code: 'HU', name: 'Hungary' },
    { code: 'RO', name: 'Romania' },
    { code: 'BG', name: 'Bulgaria' },
    { code: 'HR', name: 'Croatia' },
    { code: 'SK', name: 'Slovakia' },
    { code: 'SI', name: 'Slovenia' },
    { code: 'LT', name: 'Lithuania' },
    { code: 'LV', name: 'Latvia' },
    { code: 'EE', name: 'Estonia' },
    { code: 'JP', name: 'Japan' },
    { code: 'CN', name: 'China' },
    { code: 'KR', name: 'South Korea' },
    { code: 'IN', name: 'India' },
    { code: 'SG', name: 'Singapore' },
    { code: 'MY', name: 'Malaysia' },
    { code: 'TH', name: 'Thailand' },
    { code: 'PH', name: 'Philippines' },
    { code: 'ID', name: 'Indonesia' },
    { code: 'VN', name: 'Vietnam' },
    { code: 'NZ', name: 'New Zealand' },
    { code: 'ZA', name: 'South Africa' },
    { code: 'EG', name: 'Egypt' },
    { code: 'AE', name: 'United Arab Emirates' },
    { code: 'SA', name: 'Saudi Arabia' },
    { code: 'IL', name: 'Israel' },
    { code: 'TR', name: 'Turkey' },
    { code: 'RU', name: 'Russia' },
    { code: 'BR', name: 'Brazil' },
    { code: 'MX', name: 'Mexico' },
    { code: 'AR', name: 'Argentina' },
    { code: 'CL', name: 'Chile' },
    { code: 'CO', name: 'Colombia' },
    { code: 'PE', name: 'Peru' },
    { code: 'JM', name: 'Jamaica' },
    { code: 'BB', name: 'Barbados' },
    { code: 'BS', name: 'Bahamas' },
    { code: 'KY', name: 'Cayman Islands' },
    { code: 'TT', name: 'Trinidad and Tobago' },
    { code: 'AG', name: 'Antigua and Barbuda' },
    { code: 'DM', name: 'Dominica' },
    { code: 'GD', name: 'Grenada' },
    { code: 'LC', name: 'Saint Lucia' },
    { code: 'VC', name: 'Saint Vincent and the Grenadines' },
    { code: 'KN', name: 'Saint Kitts and Nevis' },
    { code: 'BZ', name: 'Belize' },
    { code: 'CR', name: 'Costa Rica' },
    { code: 'PA', name: 'Panama' },
    { code: 'DO', name: 'Dominican Republic' },
    { code: 'CU', name: 'Cuba' },
    { code: 'HT', name: 'Haiti' },
    { code: 'PR', name: 'Puerto Rico' },
    { code: 'GT', name: 'Guatemala' },
    { code: 'HN', name: 'Honduras' },
    { code: 'NI', name: 'Nicaragua' },
    { code: 'SV', name: 'El Salvador' },
    { code: 'EC', name: 'Ecuador' },
    { code: 'UY', name: 'Uruguay' },
    { code: 'PY', name: 'Paraguay' },
    { code: 'BO', name: 'Bolivia' },
    { code: 'VE', name: 'Venezuela' },
    { code: 'GY', name: 'Guyana' },
    { code: 'SR', name: 'Suriname' },
    { code: 'GF', name: 'French Guiana' },
    { code: 'FK', name: 'Falkland Islands' },
    { code: 'GS', name: 'South Georgia and the South Sandwich Islands' },
    { code: 'AQ', name: 'Antarctica' },
    { code: 'GL', name: 'Greenland' },
    { code: 'IS', name: 'Iceland' },
    { code: 'FO', name: 'Faroe Islands' },
    { code: 'MT', name: 'Malta' },
    { code: 'CY', name: 'Cyprus' },
    { code: 'LU', name: 'Luxembourg' },
    { code: 'LI', name: 'Liechtenstein' },
    { code: 'MC', name: 'Monaco' },
    { code: 'SM', name: 'San Marino' },
    { code: 'VA', name: 'Vatican City' },
    { code: 'AD', name: 'Andorra' },
    { code: 'BY', name: 'Belarus' },
    { code: 'UA', name: 'Ukraine' },
    { code: 'MD', name: 'Moldova' },
    { code: 'MK', name: 'North Macedonia' },
    { code: 'AL', name: 'Albania' },
    { code: 'BA', name: 'Bosnia and Herzegovina' },
    { code: 'ME', name: 'Montenegro' },
    { code: 'RS', name: 'Serbia' },
    { code: 'XK', name: 'Kosovo' },
    { code: 'BH', name: 'Bahrain' },
    { code: 'KW', name: 'Kuwait' },
    { code: 'OM', name: 'Oman' },
    { code: 'QA', name: 'Qatar' },
    { code: 'YE', name: 'Yemen' },
    { code: 'IQ', name: 'Iraq' },
    { code: 'JO', name: 'Jordan' },
    { code: 'LB', name: 'Lebanon' },
    { code: 'SY', name: 'Syria' },
    { code: 'PS', name: 'Palestine' },
    { code: 'KW', name: 'Kuwait' },
    { code: 'BH', name: 'Bahrain' },
    { code: 'AF', name: 'Afghanistan' },
    { code: 'PK', name: 'Pakistan' },
    { code: 'BD', name: 'Bangladesh' },
    { code: 'LK', name: 'Sri Lanka' },
    { code: 'NP', name: 'Nepal' },
    { code: 'BT', name: 'Bhutan' },
    { code: 'MV', name: 'Maldives' },
    { code: 'MM', name: 'Myanmar' },
    { code: 'LA', name: 'Laos' },
    { code: 'KH', name: 'Cambodia' },
    { code: 'BN', name: 'Brunei' },
    { code: 'TL', name: 'Timor-Leste' },
    { code: 'MN', name: 'Mongolia' },
    { code: 'KP', name: 'North Korea' },
    { code: 'TW', name: 'Taiwan' },
    { code: 'HK', name: 'Hong Kong' },
    { code: 'MO', name: 'Macau' },
    { code: 'KZ', name: 'Kazakhstan' },
    { code: 'UZ', name: 'Uzbekistan' },
    { code: 'TM', name: 'Turkmenistan' },
    { code: 'TJ', name: 'Tajikistan' },
    { code: 'KG', name: 'Kyrgyzstan' },
    { code: 'AF', name: 'Afghanistan' },
    { code: 'IR', name: 'Iran' },
    { code: 'IQ', name: 'Iraq' },
    { code: 'KW', name: 'Kuwait' },
    { code: 'BH', name: 'Bahrain' },
    { code: 'QA', name: 'Qatar' },
    { code: 'AE', name: 'United Arab Emirates' },
    { code: 'OM', name: 'Oman' },
    { code: 'YE', name: 'Yemen' },
    { code: 'SA', name: 'Saudi Arabia' },
    { code: 'JO', name: 'Jordan' },
    { code: 'LB', name: 'Lebanon' },
    { code: 'SY', name: 'Syria' },
    { code: 'PS', name: 'Palestine' },
    { code: 'IL', name: 'Israel' },
    { code: 'TR', name: 'Turkey' },
    { code: 'GE', name: 'Georgia' },
    { code: 'AM', name: 'Armenia' },
    { code: 'AZ', name: 'Azerbaijan' },
    { code: 'KE', name: 'Kenya' },
    { code: 'TZ', name: 'Tanzania' },
    { code: 'UG', name: 'Uganda' },
    { code: 'RW', name: 'Rwanda' },
    { code: 'ET', name: 'Ethiopia' },
    { code: 'SO', name: 'Somalia' },
    { code: 'DJ', name: 'Djibouti' },
    { code: 'ER', name: 'Eritrea' },
    { code: 'SD', name: 'Sudan' },
    { code: 'SS', name: 'South Sudan' },
    { code: 'CF', name: 'Central African Republic' },
    { code: 'TD', name: 'Chad' },
    { code: 'CM', name: 'Cameroon' },
    { code: 'GA', name: 'Gabon' },
    { code: 'CG', name: 'Congo' },
    { code: 'CD', name: 'Democratic Republic of the Congo' },
    { code: 'AO', name: 'Angola' },
    { code: 'ZM', name: 'Zambia' },
    { code: 'ZW', name: 'Zimbabwe' },
    { code: 'BW', name: 'Botswana' },
    { code: 'NA', name: 'Namibia' },
    { code: 'SZ', name: 'Eswatini' },
    { code: 'LS', name: 'Lesotho' },
    { code: 'MW', name: 'Malawi' },
    { code: 'MZ', name: 'Mozambique' },
    { code: 'MG', name: 'Madagascar' },
    { code: 'MU', name: 'Mauritius' },
    { code: 'SC', name: 'Seychelles' },
    { code: 'KM', name: 'Comoros' },
    { code: 'CV', name: 'Cape Verde' },
    { code: 'GW', name: 'Guinea-Bissau' },
    { code: 'GN', name: 'Guinea' },
    { code: 'SL', name: 'Sierra Leone' },
    { code: 'LR', name: 'Liberia' },
    { code: 'CI', name: 'Ivory Coast' },
    { code: 'GH', name: 'Ghana' },
    { code: 'TG', name: 'Togo' },
    { code: 'BJ', name: 'Benin' },
    { code: 'NE', name: 'Niger' },
    { code: 'BF', name: 'Burkina Faso' },
    { code: 'ML', name: 'Mali' },
    { code: 'SN', name: 'Senegal' },
    { code: 'GM', name: 'Gambia' },
    { code: 'MR', name: 'Mauritania' },
    { code: 'DZ', name: 'Algeria' },
    { code: 'TN', name: 'Tunisia' },
    { code: 'LY', name: 'Libya' },
    { code: 'MA', name: 'Morocco' },
    { code: 'EH', name: 'Western Sahara' },
    { code: 'AU', name: 'Australia' },
    { code: 'NZ', name: 'New Zealand' },
    { code: 'PG', name: 'Papua New Guinea' },
    { code: 'FJ', name: 'Fiji' },
    { code: 'NC', name: 'New Caledonia' },
    { code: 'PF', name: 'French Polynesia' },
    { code: 'WS', name: 'Samoa' },
    { code: 'TO', name: 'Tonga' },
    { code: 'VU', name: 'Vanuatu' },
    { code: 'SB', name: 'Solomon Islands' },
    { code: 'KI', name: 'Kiribati' },
    { code: 'TV', name: 'Tuvalu' },
    { code: 'NR', name: 'Nauru' },
    { code: 'PW', name: 'Palau' },
    { code: 'FM', name: 'Micronesia' },
    { code: 'MH', name: 'Marshall Islands' },
    { code: 'CK', name: 'Cook Islands' },
    { code: 'NU', name: 'Niue' },
    { code: 'TK', name: 'Tokelau' },
    { code: 'AS', name: 'American Samoa' },
    { code: 'GU', name: 'Guam' },
    { code: 'MP', name: 'Northern Mariana Islands' },
    { code: 'VI', name: 'U.S. Virgin Islands' },
    { code: 'VG', name: 'British Virgin Islands' },
    { code: 'AI', name: 'Anguilla' },
    { code: 'MS', name: 'Montserrat' },
    { code: 'TC', name: 'Turks and Caicos Islands' },
    { code: 'BM', name: 'Bermuda' },
    { code: 'GI', name: 'Gibraltar' },
    { code: 'JE', name: 'Jersey' },
    { code: 'GG', name: 'Guernsey' },
    { code: 'IM', name: 'Isle of Man' },
    { code: 'AX', name: 'Åland Islands' },
    { code: 'SJ', name: 'Svalbard and Jan Mayen' },
    { code: 'PM', name: 'Saint Pierre and Miquelon' },
    { code: 'BL', name: 'Saint Barthélemy' },
    { code: 'MF', name: 'Saint Martin' },
    { code: 'SX', name: 'Sint Maarten' },
    { code: 'CW', name: 'Curaçao' },
    { code: 'AW', name: 'Aruba' },
    { code: 'BQ', name: 'Caribbean Netherlands' },
    { code: 'GP', name: 'Guadeloupe' },
    { code: 'MQ', name: 'Martinique' },
    { code: 'RE', name: 'Réunion' },
    { code: 'YT', name: 'Mayotte' },
    { code: 'SH', name: 'Saint Helena' },
    { code: 'ST', name: 'São Tomé and Príncipe' },
    { code: 'GQ', name: 'Equatorial Guinea' },
    { code: 'BI', name: 'Burundi' },
    { code: 'RW', name: 'Rwanda' },
    { code: 'DJ', name: 'Djibouti' },
    { code: 'ER', name: 'Eritrea' },
    { code: 'SS', name: 'South Sudan' },
    { code: 'CF', name: 'Central African Republic' },
    { code: 'TD', name: 'Chad' },
    { code: 'CM', name: 'Cameroon' },
    { code: 'GA', name: 'Gabon' },
    { code: 'CG', name: 'Congo' },
    { code: 'CD', name: 'Democratic Republic of the Congo' },
    { code: 'AO', name: 'Angola' },
    { code: 'ZM', name: 'Zambia' },
    { code: 'ZW', name: 'Zimbabwe' },
    { code: 'BW', name: 'Botswana' },
    { code: 'NA', name: 'Namibia' },
    { code: 'SZ', name: 'Eswatini' },
    { code: 'LS', name: 'Lesotho' },
    { code: 'MW', name: 'Malawi' },
    { code: 'MZ', name: 'Mozambique' },
    { code: 'MG', name: 'Madagascar' },
    { code: 'MU', name: 'Mauritius' },
    { code: 'SC', name: 'Seychelles' },
    { code: 'KM', name: 'Comoros' },
    { code: 'CV', name: 'Cape Verde' },
    { code: 'GW', name: 'Guinea-Bissau' },
    { code: 'GN', name: 'Guinea' },
    { code: 'SL', name: 'Sierra Leone' },
    { code: 'LR', name: 'Liberia' },
    { code: 'CI', name: 'Ivory Coast' },
    { code: 'GH', name: 'Ghana' },
    { code: 'TG', name: 'Togo' },
    { code: 'BJ', name: 'Benin' },
    { code: 'NE', name: 'Niger' },
    { code: 'BF', name: 'Burkina Faso' },
    { code: 'ML', name: 'Mali' },
    { code: 'SN', name: 'Senegal' },
    { code: 'GM', name: 'Gambia' },
    { code: 'MR', name: 'Mauritania' },
    { code: 'DZ', name: 'Algeria' },
    { code: 'TN', name: 'Tunisia' },
    { code: 'LY', name: 'Libya' },
    { code: 'MA', name: 'Morocco' },
    { code: 'EH', name: 'Western Sahara' },
];

// Remove duplicates based on country code and sort alphabetically
const COUNTRIES = COUNTRIES_RAW.filter((country, index, self) =>
    index === self.findIndex(c => c.code === country.code)
).sort((a, b) => a.name.localeCompare(b.name));

// Export COUNTRIES for use in other components
export { COUNTRIES };

const CountrySelectionModal = ({ open, onClose, detectedCountry }) => {
    const { setSelectedCountry } = useCountryStore();
    const [selectedCountryCode, setSelectedCountryCode] = useState(null);

    useEffect(() => {
        // Set initial selected country to detected country
        if (detectedCountry?.code) {
            setSelectedCountryCode(detectedCountry.code);
        }
    }, [detectedCountry]);

    const handleConfirm = () => {
        const country = COUNTRIES.find(c => c.code === selectedCountryCode);
        if (country) {
            setSelectedCountry(country);
            onClose();
        }
    };

    const handleCountryChange = (value) => {
        setSelectedCountryCode(value);
    };

    return (
        <Modal
            title="Select Your Country"
            open={open}
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Cancel
                </Button>,
                <Button key="confirm" type="primary" onClick={handleConfirm} disabled={!selectedCountryCode}>
                    OK
                </Button>,
            ]}
            closable={false}
            maskClosable={false}
            centered
            width={500}
        >
            <div className="flex flex-col gap-4 py-4">
                <p className="text-[#778088]">
                    {detectedCountry 
                        ? `We detected you're in ${detectedCountry.name}. Is this correct?`
                        : 'Please select your home country to continue'
                    }
                </p>
                <div>
                    <label className="block text-sm font-medium text-[#13253F] mb-2">
                        Country
                    </label>
                    <Select
                        value={selectedCountryCode}
                        onChange={handleCountryChange}
                        placeholder="Select a country"
                        className="w-full"
                        showSearch
                        filterOption={(input, option) =>
                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                        options={COUNTRIES.map(country => ({
                            value: country.code,
                            label: country.name,
                        }))}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default CountrySelectionModal;

